import { render, staticRenderFns } from "./kisvideo.vue?vue&type=template&id=348d089e&scoped=true&"
import script from "./kisvideo.vue?vue&type=script&lang=js&"
export * from "./kisvideo.vue?vue&type=script&lang=js&"
import style0 from "./kisvideo.vue?vue&type=style&index=0&id=348d089e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d089e",
  null
  
)

export default component.exports